import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
// logic
import { useTranslation } from 'react-i18next';
// state
import { useDispatch } from 'react-redux';
import { actions as uiActions } from 'state/ui';
// style
import styled, { css } from 'styled-components';
import { media } from 'utils/style';
// components
import { ExpandIcon, CollapseIcon } from 'refactored/ui/icons';
import MainMenuButton from 'refactored/ui/nav/mainMenu/MainMenuButton';
import MainMenuSeparator from 'refactored/ui/nav/mainMenu/MainMenuSeparator';

const MainMenuCollapseButton = ({ className, isCollapsed }) => {
  const { t } = useTranslation(['mainMenu']);
  const dispatch = useDispatch();

  const text = isCollapsed ? t('show_menu') : t('hide_menu');
  const icon = isCollapsed ? <ExpandIcon /> : <CollapseIcon />;

  const toggleMainMenu = useCallback(
    () => dispatch(uiActions.toggleMainMenu()),
    [dispatch]
  );

  return (
    <div className={className}>
      <MainMenuSeparator />
      <MainMenuButton
        isCollapsed={isCollapsed}
        text={text}
        icon={icon}
        variant="TEXT_HIDDEN"
        onClick={toggleMainMenu}
      />
    </div>
  );
};

MainMenuCollapseButton.propTypes = {
  isCollapsed: PropTypes.bool,
  className: PropTypes.string,
};

const regularCSS = css`
  display: none;
`;

const tabletCSS = css`
  display: inherit;
`;

export default styled(MainMenuCollapseButton)`
  ${regularCSS};
  ${media.lessThan('huge')`${tabletCSS}`};
`;
